import React,{useEffect, useState} from "react";
import {
  ChevronLeft,
  ChevronRight,
  ChevronsLeft,
  ChevronsRight,
} from "lucide-react";
import {
  Pagination,
  PaginationContent,
  PaginationEllipsis,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious,
} from "../../components/ui/pagination";

const IntegratedPagination = ({
  currentPage,
  setCurrentPage,
  totalPages,
  position = "justify-center",
}) => {
  // Responsive state
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 640);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  useEffect(() => {
    if (currentPage < 1) {
      setCurrentPage(1);
    }
  }, [currentPage, setCurrentPage]);

  const handlePageChange = (page) => {
    if (page !== currentPage && page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const renderPageNumbers = () => {
  let pageNumbers = [];
  let showFirstEllipsis = false;
  let showLastEllipsis = false;

  if (isMobile) {
    // Always show 1, 2, currentPage, last (N), with ellipsis as needed
    if (totalPages <= 4) {
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(
          <PaginationItem key={i}>
            <PaginationLink
              onClick={() => handlePageChange(i)}
              isActive={i === currentPage}
            >
              {i}
            </PaginationLink>
          </PaginationItem>
        );
      }
      return { pageNumbers, showEllipsis: false, showSecondEllipsis: false };
    } else {
      // Always show 1, 2
      pageNumbers.push(
        <PaginationItem key={1}>
          <PaginationLink
            onClick={() => handlePageChange(1)}
            isActive={currentPage === 1}
          >
            1
          </PaginationLink>
        </PaginationItem>
      );
      pageNumbers.push(
        <PaginationItem key={2}>
          <PaginationLink
            onClick={() => handlePageChange(2)}
            isActive={currentPage === 2}
          >
            2
          </PaginationLink>
        </PaginationItem>
      );

      // Show ellipsis if currentPage > 3
      let showFirstEllipsis = currentPage > 3;
      if (showFirstEllipsis) {
        pageNumbers.push(
          <PaginationItem key="ellipsis1">
            <PaginationEllipsis />
          </PaginationItem>
        );
      }

      // Show current page if it's not 1, 2, or last
      if (currentPage !== 1 && currentPage !== 2 && currentPage !== totalPages) {
        pageNumbers.push(
          <PaginationItem key={currentPage}>
            <PaginationLink
              onClick={() => handlePageChange(currentPage)}
              isActive={true}
            >
              {currentPage}
            </PaginationLink>
          </PaginationItem>
        );
      }

      // Show ellipsis if currentPage is not last-1 or last
      let showSecondEllipsis = currentPage < totalPages - 1;
      if (showSecondEllipsis) {
        pageNumbers.push(
          <PaginationItem key="ellipsis2">
            <PaginationEllipsis />
          </PaginationItem>
        );
      }

      // Always show last page
      pageNumbers.push(
        <PaginationItem key={totalPages}>
          <PaginationLink
            onClick={() => handlePageChange(totalPages)}
            isActive={currentPage === totalPages}
          >
            {totalPages}
          </PaginationLink>
        </PaginationItem>
      );

      return { pageNumbers, showEllipsis: false };
    }
  } else {
    // Desktop logic for design: 1 ... X-1 X X+1 ... N
    if (totalPages <= 7) {
      // Show all pages if not too many
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(
          <PaginationItem key={i}>
            <PaginationLink
              onClick={() => handlePageChange(i)}
              isActive={i === currentPage}
            >
              {i}
            </PaginationLink>
          </PaginationItem>
        );
      }
    } else {
      // Always show first page
      pageNumbers.push(
        <PaginationItem key={1}>
          <PaginationLink
            onClick={() => handlePageChange(1)}
            isActive={currentPage === 1}
          >
            1
          </PaginationLink>
        </PaginationItem>
      );

      // Show first ellipsis if needed
      if (currentPage > 4) {
        pageNumbers.push(
          <PaginationItem key="start-ellipsis">
            <PaginationEllipsis />
          </PaginationItem>
        );
      }

      // Show pages around current page
      let start = Math.max(2, currentPage - 1);
      let end = Math.min(totalPages - 1, currentPage + 1);

      // Adjust window if near the start
      if (currentPage <= 4) {
        start = 2;
        end = 4;
      }
      // Adjust window if near the end
      if (currentPage >= totalPages - 3) {
        start = totalPages - 3;
        end = totalPages - 1;
      }

      for (let i = start; i <= end; i++) {
        pageNumbers.push(
          <PaginationItem key={i}>
            <PaginationLink
              onClick={() => handlePageChange(i)}
              isActive={i === currentPage}
            >
              {i}
            </PaginationLink>
          </PaginationItem>
        );
      }

      // Show last ellipsis if needed
      if (currentPage < totalPages - 3) {
        pageNumbers.push(
          <PaginationItem key="end-ellipsis">
            <PaginationEllipsis />
          </PaginationItem>
        );
      }

      // Always show last page
      pageNumbers.push(
        <PaginationItem key={totalPages}>
          <PaginationLink
            onClick={() => handlePageChange(totalPages)}
            isActive={currentPage === totalPages}
          >
            {totalPages}
          </PaginationLink>
        </PaginationItem>
      );
    }
    return { pageNumbers, showEllipsis: false };
  }
};
const { pageNumbers, showEllipsis} = renderPageNumbers();
const goToPrevPage = () => {
  if (currentPage > 1) {
    handlePageChange(currentPage - 1);
  }
};

const goToNextPage = () => {
  if (currentPage < totalPages) {
    handlePageChange(currentPage + 1);
  }
};
console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>",currentPage)
  return (
    <Pagination className={`mt-5 cursor-pointer ${position}`}>
      <PaginationContent>
        <PaginationItem>
          <PaginationPrevious
            onClick={goToPrevPage}
            disabled={currentPage === 1}
            className = "text-lg"
          />
        </PaginationItem>

        {pageNumbers}

        {/* Only show ellipsis and last page on desktop */}
        {isMobile && showEllipsis && (
          <>
            <PaginationItem>
              <PaginationEllipsis />
            </PaginationItem>
            <PaginationItem>
              <PaginationLink
                onClick={() => handlePageChange(totalPages)}
                isActive={totalPages === currentPage}
              >
                {totalPages}
              </PaginationLink>
            </PaginationItem>
          </>
        )}

        {/* Desktop: show ellipsis and last page if needed */}
      {!isMobile && showEllipsis && (
        <>
          <PaginationItem>
            <PaginationEllipsis />
          </PaginationItem>
          <PaginationItem>
            <PaginationLink
              onClick={() => handlePageChange(totalPages)}
              isActive={totalPages === currentPage}
            >
              {totalPages}
            </PaginationLink>
          </PaginationItem>
        </>
      )}

        <PaginationItem>
          <PaginationNext
            onClick={goToNextPage}
            disabled={currentPage === totalPages}
            className = "text-lg"
          />
        </PaginationItem>
      </PaginationContent>
    </Pagination>
  );
};

export default IntegratedPagination;
